import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, provide } from 'intact-react';
import template from './index.vdt';
import { TABS } from './constants';
import { sizes } from '../../styles/utils';
import { useActiveBar } from './useActiveBar';
import { useScroll } from './useScroll';
import { useConfigContext } from '../config';
export * from './tab';
var typeDefs = {
  value: null,
  vertical: Boolean,
  size: sizes,
  type: ['default', 'card', 'flat-card'],
  closable: Boolean,
  beforeChange: Function
};
var defaults = function defaults() {
  return {
    size: 'default',
    type: 'default'
  };
};
var events = {
  remove: true
};
export var Tabs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tabs, _Component);
  function Tabs() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.activeBar = useActiveBar();
    _this.scroll = useScroll();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Tabs.prototype;
  _proto.init = function init() {
    provide(TABS, this);
  };
  _proto.changeTab = /*#__PURE__*/function () {
    var _changeTab = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tabProps) {
      var _this$get, beforeChange, ret;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$get = this.get(), beforeChange = _this$get.beforeChange;
            if (!beforeChange) {
              _context2.next = 7;
              break;
            }
            _context2.next = 4;
            return beforeChange(tabProps.value);
          case 4:
            ret = _context2.sent;
            if (ret) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return");
          case 7:
            // if exits 'to', we don't change the value,
            // but let the page to change it by passing the value prop
            if (!tabProps.to) {
              this.set('value', tabProps.value);
              // } else if (this.$router) {
              // this.$router.push(item.to);
            } else {
              window.location.href = tabProps.to;
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee, this);
    }));
    function changeTab(_x) {
      return _changeTab.apply(this, arguments);
    }
    return changeTab;
  }();
  _proto.remove = function remove(value) {
    this.trigger('remove', value);
  };
  return Tabs;
}(Component);
Tabs.template = template;
Tabs.typeDefs = typeDefs;
Tabs.defaults = defaults;
Tabs.events = events;